var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDropdownIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 10,
    viewBox: "0 0 24 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6451 3.45873C13.5936 3.40081 13.56 3.32927 13.5483 3.25272C13.5366 3.17616 13.5473 3.09784 13.579 3.0272C13.6108 2.95656 13.6623 2.8966 13.7273 2.85455C13.7923 2.81249 13.8682 2.79013 13.9456 2.79015H20.3743C20.4517 2.79013 20.5275 2.81249 20.5926 2.85455C20.6576 2.8966 20.7091 2.95656 20.7408 3.0272C20.7726 3.09784 20.7833 3.17616 20.7715 3.25272C20.7598 3.32927 20.7262 3.40081 20.6748 3.45873L17.4605 7.07485C17.4228 7.11733 17.3765 7.15135 17.3247 7.17464C17.2729 7.19793 17.2167 7.20997 17.1599 7.20997C17.1031 7.20997 17.047 7.19793 16.9952 7.17464C16.9434 7.15135 16.8971 7.11733 16.8594 7.07485L13.6451 3.45873Z",
    fill: "#484848"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22.6421,
    height: 9,
    rx: 0.5,
    stroke: "#484848",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIcon);
export default __webpack_public_path__ + "static/media/dropdown_icon.e4c30adfafe14580be1ed3295b58a92d.svg";
export { ForwardRef as ReactComponent };